import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConditionalErrorsModalComponent } from './conditional-errors-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ConditionalErrorsModalService {

	constructor(private modalService: NgbModal) {}

	public confirm(
	  title: string,
	  message: Array<any>,
	  btnOkText: string = 'OK',
	  btnCancelText: string = 'Cancel',
	  dialogSize: 'sm' | 'lg' = 'lg'
	): Promise<boolean> {
	  const modalRef = this.modalService.open(ConditionalErrorsModalComponent);
	  modalRef.componentInstance.title = title;
	  modalRef.componentInstance.msgs = message;
	  modalRef.componentInstance.btnOkText = btnOkText;
	  modalRef.componentInstance.btnCancelText = btnCancelText;

	  return modalRef.result;
	}

	public showModalWithCustomHTML(
	  title: string,
	  message: string,
	  btnOkText: string = 'OK',
	  btnCancelText: string = 'Cancel',
	  dialogSize: 'sm' | 'lg' = 'lg'
	): Promise<boolean> {
	  const modalRef = this.modalService.open(ConditionalErrorsModalComponent);
	  modalRef.componentInstance.title = title;
	  modalRef.componentInstance.msgs = message;
	  modalRef.componentInstance.btnOkText = btnOkText;
	  modalRef.componentInstance.btnCancelText = btnCancelText;
	  modalRef.componentInstance.isHTML = true;

	  return modalRef.result;
	}
}
